"use client";

import { useEffect } from "react";
import { logError } from "@/app/_actions/log-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);

    logError({
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: typeof window !== "undefined" ? window.location.href : "unknown",
      userAgent:
        typeof navigator !== "undefined" ? navigator.userAgent : "unknown",
    });
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>Something went wrong</h1>
          <p>
            Error ID: <code>{error.digest ?? "unknown"}</code>
          </p>
          <button onClick={reset}>Try again</button>
        </div>
      </body>
    </html>
  );
}
